import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {Breadcrumb, Col, Container, Row} from 'react-bootstrap';
import {Carousel} from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Api from '../../../services/Api';
import HelperGeneral from '../../../helpers/HelperGeneral';
import ReactHtmlParser from 'react-html-parser';
import {faAngleLeft, faMinus, faPlus, faShoppingBasket, faHouse, faBan} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import BasketInfo from "./basket/BasketInfo";
import {setBasketList, setRightBasketModal} from "../../../services/redux/actions/BasketAction";
import CategorySideBar from "../../partials/CategorySideBar";
import {Button, Spin} from "antd";
import UserInfo from "../../auth/UserInfo";

class Product extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            filterShow: [],
            info: {},
            quantity: 1,
            width: window.innerWidth,
            link: "/kategori/daily/temel-bakim",
            loading: false,
            basketAddLoading: false,
        }
    }

    updateWidth = () => {
        this.setState({width: window.innerWidth});
    };

    componentDidMount() {
        const product_id = this.props?.match?.params?.product_id;
        if (!product_id) {
            HelperGeneral.pageChange(this, '/home');
            return null;
        }
        window.scroll(0, 0);
        window.addEventListener('resize', this.updateWidth);
        this.getProduct(product_id);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const product_id = this.props?.match?.params?.product_id;
        if (prevProps?.match?.params?.product_id !== product_id) {
            this.getProduct(product_id);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth);
    }

    getProduct(product_id) {
        this.setState({loading: true});
        Api.getProductDetail(product_id).then((e) => {
            this.setState({
                info: e?.data,
            }, () => {
                this.setState({loading: false});
            })
        }).catch((e) => {
            this.setState({loading: false})
            HelperGeneral.alert(e);
            HelperGeneral.pageChange(this, '/home');
        })
    }

    increment(quantity) {
        HelperGeneral.alert("Aylık hediye ürün sipariş limiti 1 olduğu için ürün adeti arttırılamamaktadır.")
        // const newQuantity = ++quantity;
        // this.setState({quantity: newQuantity})
    }

    decrement(quantity) {
        const newQuantity = quantity > 1 ? --quantity : 1;
        this.setState({quantity: newQuantity});
    }

    setBasketItem = (item, quantity = 1) => {
        this.setState({basketAddLoading: true});
        const basketRaw = localStorage.getItem("basketList");
        const basket = basketRaw ? JSON.parse(basketRaw) : {products: []};

        const products = Array.isArray(basket.products) ? basket.products : [];

        const exists = products.some(p => Number(p.product_id) === Number(item?.id));

        if (exists) {
            this.setState({basketAddLoading: false});
            HelperGeneral.alert("Ürün sepette bulunmaktadır", "warning");
            return;
        }

        if (products?.length === 1) {
            this.setState({basketAddLoading: false});
            HelperGeneral.alert("Aylık hediye ürün sipariş limiti 1 olduğu için ürün sepete eklenemedi.")
            return;
        }

        const data = {
            product_id: item?.id,
            quantity: quantity,
            type: 1,
            uniqid: Api.uuidv4(),
            gift_product: 1
        };

        Api.addBasket(data).then((res) => {
            Api.getBasket().then((response) => {
                if (response?.data.products?.length > 0) {
                    this.setState({basketAddLoading: false});
                    localStorage.setItem("basketList", JSON.stringify(response?.data));
                    setBasketList(response?.data?.products);
                    setRightBasketModal(true);
                } else {
                    this.setState({basketAddLoading: false});
                    localStorage.removeItem("basketList");
                    setBasketList([]);
                }
            }).catch((e) => {
                this.setState({basketAddLoading: false});
                HelperGeneral.alert(e);
            });
        });
    }

    render() {
        const {info, quantity, width, loading, basketAddLoading} = this.state;

        return (
            <div className={'product-detail pb-0 pb-sm-5'}>
                <Container>
                    <Row>
                        {
                            width > 767 && (
                                <Col sm={6} lg={3} md={3} xxl={3} className={'mt-3'}>
                                    <Row>
                                        <CategorySideBar productDetailSlug={info?.categoryInfos?.all[0]?.slug}/>
                                    </Row>
                                </Col>
                            )
                        }
                        <Col xs={12} lg={9} md={9} xxl={9} className={'mt-3'}>
                            <Spin spinning={loading}>
                                <Row>
                                    <Col xs={12}>
                                        <Breadcrumb>
                                            <a onClick={() => window.history.back()}>
                                                <FontAwesomeIcon
                                                    icon={faAngleLeft}
                                                    className={'me-3'}
                                                    style={{
                                                        color: '#52585B',
                                                        fontSize: width > 767 ? 18 : 14,
                                                        paddingTop: 2,
                                                    }}
                                                />
                                            </a>
                                            <Breadcrumb.Item linkAs={Link} linkProps={{to: '/home'}}>
                                                <FontAwesomeIcon
                                                    icon={faHouse}
                                                    className={'me-0'}
                                                    style={{
                                                        color: '#52585B',
                                                        fontSize: width > 767 ? 18 : 14,
                                                        paddingTop: 0,
                                                    }}
                                                />
                                            </Breadcrumb.Item>
                                            <Breadcrumb.Item linkAs={Link} linkProps={{to: this.state.link}}>Ürünler</Breadcrumb.Item>
                                            <Breadcrumb.Item linkAs={Link} linkProps={{to: '/kategori/' + info?.categoryInfos?.all[0]?.slug}}>
                                                {info?.categoryInfos?.all[0]?.name?.split("/")[0].trim()}
                                            </Breadcrumb.Item>
                                            <Breadcrumb.Item active>{info?.name}</Breadcrumb.Item>
                                        </Breadcrumb>
                                    </Col>
                                    <Col xs={12} className={'mt-2 mb-3'}>
                                        <Row>
                                            <Col xs={12} md={6}>
                                                <Carousel
                                                    showArrows={true}
                                                    showIndicators={false}
                                                    showStatus={false}
                                                    autoPlay={true}
                                                    centerSlidePercentage={true}
                                                    showThumbs={info?.images?.length > 1}
                                                >
                                                    {
                                                        info?.images ? (
                                                            info?.images?.map((v, i) => (
                                                                <div key={i}>
                                                                    <img
                                                                        src={v?.w450x450}
                                                                        alt={info?.name}
                                                                        className={'product-image rounded'}
                                                                    />
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div>
                                                                <img
                                                                    src={require('../../../assets/images/png/default-product.png')}
                                                                    alt={info?.name}
                                                                    className={'product-image rounded'}
                                                                />
                                                            </div>
                                                        )
                                                    }
                                                </Carousel>
                                            </Col>
                                            <Col xs={12} md={6}>
                                                <h3 className={'frame pt-0 title'}>{info?.name}</h3>
                                                {
                                                    info?.brief_description && (
                                                        <div className={'alt_tag frame mt-3'}>{info?.brief_description?.split(/\r?\n/)[0]}</div>
                                                    )
                                                }
                                                {
                                                    (info?.gift_product === 1 && info?.gift_point > 0) && (
                                                        <>
                                                            {
                                                                info?.gift_point && (
                                                                    <div className={'frame point'}>
                                                                        <div className={'gift'}>
                                                                            <span>{HelperGeneral.formatPoint(info?.gift_point)}</span>
                                                                            <img
                                                                                src={require('../../../assets/images/png/theme/q-point-logo.png')}
                                                                                className={'q-point-logo'}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }
                                                            <div className={'frame brief_description mt-3 mb-3'}>
                                                                <Row className={'basket'}>
                                                                    <Col xs={12} md={'auto'} className={'quantity-input-col'}>
                                                                        <div className={"quantity-input"}>
                                                                            <button
                                                                                disabled={quantity === 1 || info?.inStock < 1}
                                                                                className={"quantity-input__modifier quantity-input__modifier--left product"}
                                                                                onClick={() => this.decrement(quantity)}
                                                                            >
                                                                                <FontAwesomeIcon icon={faMinus} size={5}/>
                                                                            </button>
                                                                            <input
                                                                                className={"quantity-input__screen"}
                                                                                type={"text"}
                                                                                value={quantity}
                                                                                readOnly={true}
                                                                            />
                                                                            <button
                                                                                className={"quantity-input__modifier quantity-input__modifier--right product"}
                                                                                disabled={info?.inStock < 1}
                                                                                onClick={() => this.increment(quantity)}
                                                                            >
                                                                                <FontAwesomeIcon icon={faPlus} size={5}/>
                                                                            </button>
                                                                        </div>
                                                                    </Col>
                                                                    <Col xs={12} md={true}>
                                                                        {
                                                                            info?.inStock < 1 ? (
                                                                                <Button
                                                                                    loading={basketAddLoading}
                                                                                    className={'btn btn-primary-2'}
                                                                                    disabled={true}
                                                                                >
                                                                                    <FontAwesomeIcon icon={faBan} className={'me-1'}/> Stok Tükendi
                                                                                </Button>
                                                                            ) : (
                                                                                <Button
                                                                                    loading={basketAddLoading}
                                                                                    className={'btn btn-primary-2'}
                                                                                    onClick={() => {
                                                                                        this.setBasketItem(info);
                                                                                    }}
                                                                                >
                                                                                    <FontAwesomeIcon icon={faShoppingBasket} className={'me-2'}/> Sepete Ekle
                                                                                </Button>
                                                                            )
                                                                        }
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                                {
                                                    info?.descriptions?.length > 0 && info?.descriptions[3] && info?.descriptions[3]?.description && (
                                                        <div className={'brief_description frame mb-3'}>
                                                            {ReactHtmlParser(info?.descriptions[3]?.description)}
                                                        </div>
                                                    )
                                                }
                                                <div className={'frame link'}>
                                                    <span>Ayrıntılı bilgi için: </span> <a className={'redirect-link'} target={'_blank'} href={'https://shiniq.com/'}>https://shiniq.com/</a>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Spin>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}

export default withRouter(Product);
